'use client'

import { useCheckout, useModals } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { CustomReference } from '@/components/forms'

interface CustomReferenceModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const CustomReferenceModal = ({ open }: CustomReferenceModalProps) => {
  const { closeModal, closeAll } = useModals()
  const { payment_method } = useCheckout()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('CUSTOM_REFERENCE')}
        size="lg"
      >
        <DialogHeader>
          <DialogTitle>Gift Card</DialogTitle>
          <DialogDescription>
            Please enter the barcode of the Gift Card
          </DialogDescription>
        </DialogHeader>

        {open && <CustomReference onClose={() => closeAll()} />}
      </DialogContent>
    </Dialog>
  )
}
